// Saco de fichas. Carga el catálogo, expande cantidades y reparte de forma determinista.
import tilesData from '../data/tiles-es.json';
import { createTileInstance } from './Tile.js';
import { shuffleInPlace } from '../utils/helpers.js';

/** Definiciones del catálogo (una por tipo de ficha). */
export const TILE_DEFINITIONS = tilesData.tiles;

/** Mapa defId -> definición, para consultas rápidas. */
export const DEF_BY_ID = new Map(TILE_DEFINITIONS.map((d) => [d.id, d]));

/**
 * Construye el saco de instancias (respetando `count`) y lo baraja.
 * @param {() => number} rng generador con semilla
 * @param {{ allowedTypes?: Set<string> }} [opts] si se pasa `allowedTypes`, solo entran
 *   a la bolsa las fichas cuyo `type` esté en el set (onboarding progresivo). Sin él, entran todas.
 * @returns {object[]} array de instancias de ficha
 */
export function buildBag(rng, opts = {}) {
  const allowedTypes = opts.allowedTypes || null;
  const bag = [];
  for (const def of TILE_DEFINITIONS) {
    if (allowedTypes && !allowedTypes.has(def.type)) continue; // filtro por nivel de complejidad
    const count = def.count ?? 1;
    for (let i = 0; i < count; i++) {
      bag.push(createTileInstance(def));
    }
  }
  shuffleInPlace(bag, rng);
  return bag;
}

/** Roba n fichas del final del saco (mutando el array). Devuelve las robadas. */
export function drawTiles(bag, n) {
  const drawn = [];
  for (let i = 0; i < n && bag.length > 0; i++) {
    drawn.push(bag.pop());
  }
  return drawn;
}

/** Devuelve fichas al saco y lo vuelve a barajar (p.ej. al intercambiar). */
export function returnTiles(bag, tiles, rng) {
  bag.push(...tiles);
  shuffleInPlace(bag, rng);
}
